/**
 * AuthLayout - Layout для страниц авторизации (Login, Register, Recovery)
 */

import React, { useState, useCallback } from "react";
import GuestMenu from "../menus/GuestMenu";

const AuthLayout = ({ children, showHeader = true }) => {
    const [openBurgerFn, setOpenBurgerFn] = useState(null);

    const handleSetOpenBurger = useCallback((openFn) => {
        setOpenBurgerFn(() => openFn);
    }, []);

    return (
        <div className="app-container">
            <div className="main-container main-container--quest">
                {showHeader && (
                    <header className="header">
                        <div>
                            <button
                                className="burger-button"
                                onClick={() => openBurgerFn && openBurgerFn()}
                                aria-label="Меню"
                            >
                                <div></div>
                            </button>
                            <GuestMenu onTrigger={handleSetOpenBurger} />
                        </div>
                    </header>
                )}

                <main className="main-auth">{children}</main>
            </div>
        </div>
    );
};

export default AuthLayout;
